<template>
  <div>
    <p class="message" v-html="$t('discount.voucher.voucherError.info')"></p>
    <ul>
      <li class="error-message" v-for="error in errors" :key="error.source">
        {{ getErrorMessage(error) }}
      </li>
    </ul>
  </div>
</template>
<style scoped>
@import '../../../assets/css/button-style.css';

.message {
  margin: 0;
}
</style>
<script>
import { mapState } from 'vuex';
import i18nProvider from '@/lang/i18nProvider';

export default {
  name: 'voucher-error',
  computed: {
    ...mapState({
      errors: (state) => state.voucher.voucherErrors,
    }),
  },
  methods: {
    getErrorMessage(error) {
      return i18nProvider.t(`discount.voucher.voucherError.messages.${error.source}.${error.code}`);
    },
  },
};
</script>
